import { api } from "@/lib/api";

const handleUpload = async (file: File): Promise<void> => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await api.post("/upload", formData);
  return data;
};

export default handleUpload;
